// extracted by mini-css-extract-plugin
module.exports = {"cameraContainer":"Camera_cameraContainer__BBGv6","containerController":"Camera_containerController__17L8L","btnCapture":"Camera_btnCapture__2Igpy","title":"Camera_title__2dmjA"};